var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{staticClass:"mx-0",attrs:{"type":"flex","justify":"center","gutter":20}},[_c('Col',{attrs:{"span":24,"xl":21}},[_c('div',{staticClass:"layout-wrapper mt-15 mb-15"},[(_vm.renderChild)?_c('router-view'):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }